import {
  BULK_DESELECT_ALL,
  BULK_DESELECT_TRACK,
  BULK_SELECT_ALL,
  BULK_SELECT_TRACK,
  EDITED_TRACK_INIT,
  TRACK_DELETE_BATCH_SUCCESS,
  TRACK_METADATA_FETCH,
  TRACK_METADATA_FETCH_ERROR,
  TRACK_METADATA_FETCH_SUCCESS,
} from '@disco/constants/ActionTypes'
import { updateItem } from '@disco/utils/immutable'
type TrackId = number
type TSelectableTrackId = {
  trackId: number
  isSelected: boolean
}
export type State = {
  isLoading: boolean
  isLoaded: boolean
  error: Error | null | undefined
  tracks: Array<TSelectableTrackId>
}
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  tracks: [],
}
export function bulkReducer(state: State = initialState, action: any): State {
  const { type } = action

  switch (type) {
    case EDITED_TRACK_INIT: {
      const ids = action.editedTrack.trackIds || []
      return {
        ...state,
        tracks: ids.map(id => ({
          trackId: id,
          isSelected: true,
        })),
      }
    }

    // case BULK_GET_TRACKS_FOR_PLAYLIST:
    case TRACK_METADATA_FETCH: {
      if (!action.bulk) return state
      const ids = action.fetchingTracks.map(t => t.id)
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
        tracks: ids.map(id => ({
          trackId: id,
          isSelected: true,
        })),
      }
    }

    // case BULK_GET_TRACKS_FOR_PLAYLIST_SUCCESS:
    case TRACK_METADATA_FETCH_SUCCESS: {
      if (!action.bulk) return state
      const ids: Array<TrackId> = action.fetchingTracks.map(t => t.id)
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        tracks: ids.map(id => ({
          trackId: id,
          isSelected: true,
        })),
      }
    }

    // case BULK_GET_TRACKS_FOR_PLAYLIST_ERROR:
    case TRACK_METADATA_FETCH_ERROR:
      return { ...state, isLoading: false, isLoaded: true, error: action.error }

    case BULK_SELECT_TRACK: {
      const track = state.tracks[action.index]
      if (!track) return state
      return {
        ...state,
        tracks: updateItem(state.tracks, action.index, {
          ...track,
          isSelected: true,
        }),
      }
    }

    case BULK_DESELECT_TRACK: {
      const track = state.tracks[action.index]
      if (!track) return state
      return {
        ...state,
        tracks: updateItem(state.tracks, action.index, {
          ...track,
          isSelected: false,
        }),
      }
    }

    case BULK_SELECT_ALL:
      return {
        ...state,
        tracks: state.tracks.map(t => ({ ...t, isSelected: true })),
      }

    case BULK_DESELECT_ALL:
      return {
        ...state,
        tracks: state.tracks.map(t => ({ ...t, isSelected: false })),
      }

    case TRACK_DELETE_BATCH_SUCCESS:
      return {
        ...state,
        tracks: state.tracks.filter(
          track => !action.trackIds.includes(track.trackId),
        ),
      }

    default:
      return state
  }
}
